import Close from '../../../images/Close.svg';
import React from 'react';

export default function Modal({ children, onClose, ...others }) {

    return (<div className="modal" className='modal--open'>
        <div className="modal__overlay"></div>
        <div className="modal__content">
            <div className={`modal__dialog`}>
                <a onClick={onClose} title={'Close'}>
                    <img src={Close} alt={'Close'} className={`modal__close`} />
                </a>
                {children}
            </div>
        </div>
    </div>)
}